export default __webpack_public_path__ + "static/media/Warglory Boots.ac73bdd2.jpg";